module.exports = __webpack_public_path__ + "img/jzxc.46ded323.png";